export default "__VITE_ASSET__DedA2W6A__"